const GET_DEFAULT_CONTAINER_PROPS = () => ({});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
